import { useCallback } from 'react';
import { useGlobalFilterContext } from '@bingads-webui-react/global-filter-context';

const WaterfallFilterTypeDateFilter = '3';

export function useGetSummarizeMessage(i18n) {
  const filterContext = useGlobalFilterContext();
  const dateFilter = filterContext && filterContext[WaterfallFilterTypeDateFilter];

  const getTranslationKey = useCallback((rangeId, isSingleCampaign) => {
    if (rangeId) {
      if (isSingleCampaign) {
        return _TL_('Summarize the performance of campaign "{{campaignName}}" from {{startDate}} to {{endDate}}');
      }
      return _TL_('Summarize the performance of my campaigns from {{startDate}} to {{endDate}}');
    }

    return _TL_('Summarize the performance of my campaigns');
  }, []);

  const getSummarizeMessage = useCallback((campaignName) => {
    const rangeId = dateFilter && dateFilter.RangeId;
    const translationKey = getTranslationKey(rangeId, !!campaignName);

    return i18n.getString(translationKey, {
      campaignName,
      rangeDays: dateFilter && dateFilter.RangeDays,
      startDate: dateFilter && dateFilter.RangeStartDate,
      endDate: dateFilter && dateFilter.RangeEndDate,
    });
  }, [dateFilter, getTranslationKey, i18n]);

  return getSummarizeMessage;
}
